import React, { useState } from 'react';
import { X } from 'lucide-react';

/**
 * Modal for customizing widget settings
 * 
 * @param {Object} props - Component props
 * @param {boolean} props.isOpen - Whether the modal is open
 * @param {function} props.onClose - Function to close the modal
 * @param {Object} props.currentSettings - Current widget settings
 * @param {function} props.onSave - Function to save new settings
 * @param {boolean} props.templateMode - Whether to show simplified template mode
 */
const WidgetCustomizationModal = ({
    isOpen,
    onClose,
    currentSettings,
    onSave,
    templateMode = false
}) => {
    const [settings, setSettings] = useState({ ...currentSettings });

    if (!isOpen) return null;

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        if (type === 'checkbox') {
            if (name.startsWith('metrics.')) {
                const metricName = name.split('.')[1];
                setSettings({
                    ...settings,
                    metrics: {
                        ...settings.metrics,
                        [metricName]: checked
                    }
                });
            } else {
                setSettings({
                    ...settings,
                    [name]: checked
                });
            }
        } else {
            setSettings({
                ...settings,
                [name]: value
            });
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSave(settings);
        onClose();
    };

    return (
        <div className="fixed inset-0 backdrop-blur-sm flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl max-h-[90vh] overflow-y-auto">
                <div className="flex justify-end items-center pt-4 pr-4">
               
                    <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
                        <X size={20} />
                    </button>
                </div>

                <form onSubmit={handleSubmit} className="p-4">
                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Summary Prompt
                        </label>
                        <textarea
                            name="summaryPrompt"
                            value={settings.summaryPrompt}
                            onChange={handleChange}
                            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary"
                            rows={4}
                        />
                       
                    </div>



                    <div className="flex justify-end gap-2 mt-6">
                        <button
                            type="button"
                            onClick={onClose}
                            className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 bg-white hover:bg-gray-50"
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary hover:bg-primaryDark"
                        >
                            Save Changes
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default WidgetCustomizationModal;